<div class="min-h-screen bg-zinc-100 flex items-center justify-center px-4 py-10">
  <div class="w-full max-w-md rounded-2xl bg-white shadow-xl border border-zinc-200 p-6 sm:p-8">
    <div class="mb-6">
      <h1 class="text-2xl font-semibold text-zinc-900">Reset password</h1>
      <p class="mt-2 text-sm text-zinc-600">
        Choose a new password for your account.
      </p>
    </div>

    @if (validatingToken()) {
      <div class="rounded-xl border border-zinc-200 bg-zinc-50 px-4 py-4 text-sm text-zinc-700">
        Validating reset link...
      </div>
    } @else if (!tokenValid()) {
      <div class="rounded-xl border border-red-200 bg-red-50 px-4 py-4 text-sm text-red-700">
        {{ tokenError() ?? 'This reset link is invalid or expired.' }}
      </div>

      <div class="mt-5">
        <a
          routerLink="/forgot-password"
          class="inline-flex rounded-xl bg-zinc-900 px-4 py-2.5 text-sm font-medium text-white"
        >
          Request a new link
        </a>
      </div>
    } @else if (success()) {
      <div class="rounded-xl border border-emerald-200 bg-emerald-50 px-4 py-4 text-sm text-emerald-800">
        Your password has been reset successfully. Redirecting to login...
      </div>
    } @else {
      <form [formGroup]="form" (ngSubmit)="submit()" class="space-y-5">
        <div>
          <label for="password" class="block text-sm font-medium text-zinc-700 mb-1">
            New password
          </label>
          <input
            id="password"
            type="password"
            formControlName="password"
            class="w-full rounded-xl border border-zinc-300 bg-white px-4 py-3 text-zinc-900 outline-none focus:border-zinc-500"
            placeholder="Enter new password"
          />

          @if (form.controls.password.touched && form.controls.password.invalid) {
            <p class="mt-1 text-sm text-red-600">
              Password must be at least 8 characters and include upper, lower, and number.
            </p>
          }
        </div>

        <div>
          <label for="confirmPassword" class="block text-sm font-medium text-zinc-700 mb-1">
            Confirm new password
          </label>
          <input
            id="confirmPassword"
            type="password"
            formControlName="confirmPassword"
            class="w-full rounded-xl border border-zinc-300 bg-white px-4 py-3 text-zinc-900 outline-none focus:border-zinc-500"
            placeholder="Re-enter new password"
          />
        </div>

        @if (passwordMismatch()) {
          <div class="rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
            Passwords do not match.
          </div>
        }

        @if (submitError()) {
          <div class="rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
            {{ submitError() }}
          </div>
        }

        <button
          type="submit"
          [disabled]="submitting()"
          class="w-full rounded-xl bg-zinc-900 text-white py-3 font-medium disabled:opacity-60"
        >
          {{ submitting() ? 'Resetting password...' : 'Reset password' }}
        </button>
      </form>
    }

    <div class="mt-6 text-sm">
      <a routerLink="/login" class="text-zinc-700 hover:text-zinc-900 underline">
        Back to login
      </a>
    </div>
  </div>
</div>